import React from "react";
import { Link } from "react-router-dom";

/**
 * 渲染报价页侧栏的客户支持信息。
 * @returns {JSX.Element} 联系信息卡片
 */
export default function ContactDetails() {
  return (
    <div className="quote-support-card w-full border border-gray-200 bg-white p-4">
      <h2 className="mb-3 border-b pb-2 text-base font-bold text-gray-900">
        Need Help?
      </h2>
      <p className="mt-2 text-xs leading-5 text-gray-600">
        Creatyea Technology (SZ) CO Limited,
        <br />
        RM1903 - 1905, 19/F, Qiu Shi, West BLDG, Zhu Zi Lin, Fu Tian Estate,
        Shen Zhen, 518031 GD, China.
      </p>
      <Link
        className="mt-3 block text-sm font-semibold text-green-700 hover:text-green-800"
        to="mailto:hello@creatyea.com"
      >
        hello@creatyea.com
      </Link>
      <Link
        className="mt-1 block text-sm font-semibold text-green-700 hover:text-green-800"
        to="tel:+8613538239881"
      >
        +86-13538239881
      </Link>
    </div>
  );
}
